module.exports = __webpack_public_path__ + "img/1.faf2d68e.jpg";